module.exports = __webpack_public_path__ + "static/media/arrow_icon.875e9eae.svg";